<template>
  <v-card
    width="100%"
    :class="classes"
    class="zoox-card-accordion"
    v-bind="$attrs"
  >
    <div>
      <div class="accordion-title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>

      <div
        v-if="description && isDescriptionArray"
        class="body-text accordion-description"
      >
        <p v-for="(description, index) in description" :key="index">
          {{ description }}
        </p>
      </div>

      <div
        v-else-if="description && !isDescriptionArray"
        class="body-text accordion-description"
      >
        {{ description }}
      </div>

      <v-expand-transition>
        <div v-if="opened" class="accordion-content">
          <v-divider class="divider"></v-divider>
          <!--@slot Slot de conteúdo do card -->
          <slot name="content" />
        </div>
      </v-expand-transition>
    </div>

    <v-icon class="accordion-activator" @click="onChange">
      {{ opened ? openIcon : closeIcon }}
    </v-icon>
  </v-card>
</template>

<script>
/**
 * Grupo de informações que pode ser inserido breve texto explicativo, mas quando clicado, expande mais conteúdo.
 * @displayName Card Accordion
 */
export default {
  name: 'ZCardAccordion',
  model: {
    prop: 'opened',
    event: 'change',
  },
  props: {
    /**
     * Título do accordion
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * Cor da sombra do card
     */
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    /**
     * Valor do accordion (se está aberto)
     *
     * @modelName opened
     */
    opened: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Descrição do accordion
     */
    description: {
      type: [Array, String],
      required: false,
    },
    /**
     * Icon do accordion aberto
     */
    openIcon: {
      type: String,
      required: false,
      default: '$keyboard_arrow_up_rounded',
    },
    /**
     * Icon do accordion fechado
     */
    closeIcon: {
      type: String,
      required: false,
      default: '$keyboard_arrow_down_rounded',
    },
  },
  computed: {
    classes() {
      return {
        'zoox-component': true,
        ['shadow-' + this.color]: true,
      }
    },

    isDescriptionArray() {
      return Array.isArray(this.description)
    },
  },
  methods: {
    onChange() {
      /**
       * Emitido quando há alteração na abertura e fechamento do
       * accordion
       *
       * @property {boolean} opened - Valor atual do accordion
       */
      this.$emit('change', !this.opened)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@scss/variables';

@function gen_box_shadow($color) {
  @return 0px 1px 4px rgba(0, 0, 0, 0.25), inset 5px 0px 0px $color;
}

.zoox-card-accordion {
  display: flex;
  justify-content: space-between;
  border-radius: var(--component-card-radius) !important;
  padding: 15px;
  box-shadow: get_box_shadow(var(--primary));

  @each $name, $color in variables.$colors {
    &.shadow-#{$name} {
      box-shadow: gen_box_shadow($color) !important;
    }
  }

  > :first-child {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
  }

  .accordion-title {
    width: 100%;
    align-self: flex-start;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 1rem;
    margin-bottom: 10px;
  }

  .accordion-description {
    align-self: flex-start;
    color: var(--black-600);
    margin-bottom: 10px;

    p {
      margin-bottom: 8px;
    }
  }

  .accordion-activator {
    align-self: flex-start;
  }

  .accordion-content {
    height: 100%;

    .divider {
      margin-bottom: 10px;
    }
  }
}
</style>
